import { render, staticRenderFns } from "./modalStock.vue?vue&type=template&id=268e3aca"
import script from "./modalStock.vue?vue&type=script&lang=ts"
export * from "./modalStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports